import React from "react";
import ModalInterface from "../../Modal/Modal";
import "./Files.css";
import DocumentUpload from "../../DocumentUpload/UI/DocumentUpload";
import Document from "../../DocumentUpload/Domain/Document";
import { AddIcon, CustomTextArea } from "../../Utils/UI/Text";
import { CheckOutlined ,CloseOutlined } from "@ant-design/icons";

const NewFile = ({
  userId,
  handleImageUpdate,
  description,
  handleDescriptionChange,
  role,
  getByUser,
  User,
  isDescriptionValid,
  minLength,
}) => {
  const descriptionLength = description.length;
  const showError = descriptionLength > 0 && !isDescriptionValid;

  return (
    <>
      <ModalInterface
        children={
          <div className="container-document-file">
            <div className="container-document-file-item">
              <div className="description-wrapper">
                <CustomTextArea
                  label="Descripción"
                  tooltipText="Escribe una breve descripción del proyecto"
                  value={description}
                  onChange={handleDescriptionChange}
                  placeholder="Escribe una descripción"
                  maxLength={50}
                  rows={4}
                  allowClear
                  showCount
                />

                <div className="description-helper">
                  <span
                    className={
                      isDescriptionValid
                        ? "description-ok"
                        : "description-error"
                    }
                  >
                    {descriptionLength} / {minLength}{" "}
                    {isDescriptionValid ? <CheckOutlined /> : <CloseOutlined />}
                  </span>

                  {showError && (
                    <div className="description-message">
                      La descripción debe tener al menos {minLength} caracteres
                      para poder subir la imagen.
                    </div>
                  )}
                </div>
                <DocumentUpload
                  type={Document.CARBON_MANAGEMENT_FILE}
                  id={userId}
                  buttonText="Seleccionar Archivo"
                  disabled={!isDescriptionValid}
                  updateImage={handleImageUpdate}
                  description={description}
                />
              </div>
            </div>
          </div>
        }
        icon={
          role === User.CARBON_MANAGEMENT ? null : (
            <AddIcon
              onClick={() => getByUser(userId)}
              titleAdd="Agregar nuevo Archivo"
            />
          )
        }
        title="Nuevo Archivo"
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        text=""
        handleSubmit=""
        form=""
      />
    </>
  );
};

export default NewFile;
